import React from 'react';
import { graphql, StaticQuery, Link } from 'gatsby';
import { slide as Menu } from 'react-burger-menu';
import styled from 'styled-components';
import './BurgerMenu.css';

const MenuItem = styled(Link)`
  display: block;
  padding: 8px 16px;
  outline: none;
  color: ${({ currentPage }) => (currentPage ? '#24272a' : '#ffffff')};
`;

const BurgerMenu = () => {
  const isBrowser = typeof window !== 'undefined';
  const pathname = isBrowser && window.location.pathname;
  return (
    <StaticQuery
      query={graphql`
        {
          allWordpressWpApiMenusMenusItems(
            filter: { name: { eq: "Main Menu" } }
          ) {
            edges {
              node {
                items {
                  title
                  object_slug
                }
              }
            }
          }
        }
      `}
      render={(props) => (
        <div style={{height: '100%'}}>
          <Menu right>
            {props.allWordpressWpApiMenusMenusItems.edges[0].node.items.map(
              (item) => (
                <MenuItem
                  currentPage={pathname === `/${item.object_slug}`}
                  to={`/${item.object_slug}`}
                  key={item.title}
                >
                  {item.title}
                </MenuItem>
              )
            )}
          </Menu>
        </div>
      )}
    />
  );
};

export default BurgerMenu;
